import { escapeAttr, escapeHtml } from "@emkit/builder-core";
export const TEAM_DEFAULTS = {
    members: [
        {
            id: "m1",
            name: "Ada Lovelace",
            role: "CEO",
            photoUrl: "https://placehold.co/320x320/e5e7eb/6b7280?text=A",
            bio: "Leads strategy and keeps the vision focused.",
        },
        {
            id: "m2",
            name: "Alan Turing",
            role: "CTO",
            photoUrl: "https://placehold.co/320x320/e5e7eb/6b7280?text=T",
            bio: "Owns the architecture and the sharp edges.",
        },
        {
            id: "m3",
            name: "Grace Hopper",
            role: "Head of Product",
            photoUrl: "https://placehold.co/320x320/e5e7eb/6b7280?text=G",
            bio: "Translates customer pain into roadmap clarity.",
        },
    ],
    columns: 3,
    style: "card",
    background: "transparent",
    cardBackground: "#ffffff",
    textColor: "#0f172a",
    accent: "#111827",
};
export const teamWidget = {
    type: "team",
    defaultProps: TEAM_DEFAULTS,
    renderHtml(props, ctx) {
        const members = props.members ?? [];
        if (members.length === 0) {
            return `<div class="emk-team" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty — add team members in the inspector)</div>`;
        }
        const cols = props.columns ?? 3;
        const style = props.style ?? "card";
        const bg = props.background ?? "transparent";
        const cardBg = props.cardBackground ?? "#ffffff";
        const text = props.textColor ?? "#0f172a";
        const accent = props.accent ?? "#111827";
        const cards = members
            .map((m) => {
            const photo = ctx.resolveAssetUrl?.(m.photoUrl) ?? m.photoUrl;
            const avatarStyle = style === "circle"
                ? "width:128px;height:128px;border-radius:50%;object-fit:cover;display:block;margin:0 auto"
                : "width:100%;aspect-ratio:1/1;object-fit:cover;display:block";
            const socials = (m.socials ?? []).length
                ? `<div style="display:flex;gap:10px;margin-top:12px;${style === "circle" || style === "minimal" ? "justify-content:center" : ""}">${(m.socials ?? [])
                    .map((s) => `<a href="${escapeAttr(s.url)}" target="_blank" rel="noopener noreferrer" aria-label="${escapeAttr(s.platform)}" style="color:${accent};text-decoration:none;font-size:14px;width:28px;height:28px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:${accent}1a">${escapeHtml(s.icon ?? s.platform.charAt(0).toUpperCase())}</a>`)
                    .join("")}</div>`
                : "";
            const bio = m.bio
                ? `<p style="margin:6px 0 0;font-size:14px;line-height:1.55;opacity:0.75;color:${text}">${escapeHtml(m.bio)}</p>`
                : "";
            const center = style === "circle" || style === "minimal" ? "text-align:center" : "";
            const inner = `<img src="${escapeAttr(photo)}" alt="${escapeAttr(m.name)}" loading="lazy" decoding="async" style="${avatarStyle}"><div style="padding:${style === "card" ? "16px" : "12px 0 0"};${center}"><h3 style="margin:0;font-size:17px;font-weight:600;color:${text}">${escapeHtml(m.name)}</h3><div style="margin-top:2px;font-size:14px;color:${accent};font-weight:500">${escapeHtml(m.role)}</div>${bio}${socials}</div>`;
            if (style === "card") {
                return `<div class="emk-team-member" style="background:${cardBg};border:1px solid rgba(0,0,0,0.08);border-radius:12px;overflow:hidden">${inner}</div>`;
            }
            return `<div class="emk-team-member" style="padding:8px 4px">${inner}</div>`;
        })
            .join("");
        return `<div class="emk-team" style="background:${bg};padding:20px 0;font-family:inherit"><div style="display:grid;grid-template-columns:repeat(${cols},minmax(0,1fr));gap:24px;max-width:1200px;margin:0 auto">${cards}</div></div>`;
    },
};
//# sourceMappingURL=team.js.map